import { IPostValidationScope } from "./IPostValidationScope";
import { IValidateCompleteParams } from "./IValidateCompleteParams";
import { PostValidationEvent } from "./PostValidationEventEnum";

export function PostValidationDirective(eventBus: qpmn.common.tool.IEventBus, $q: angular.IQService): ng.IDirective {
    return {
        require: ["^ngModel", "^postValidation", "^form"],
        controller:[function () {
            let ctrl = this;

            ctrl.postValidateComplete = function (params: qpmn.common.tool.IEventBusParameter<IValidateCompleteParams>) {

                if (ctrl.itemName == params.args.itemName) {
                    ctrl.__deferred.resolve();
                    ctrl.__modelCtrl.$setValidity(params.args.vType, params.args.vResult);
                    
                }
            }
        }],
        link: (scope: IPostValidationScope, elements: JQLite, attributes: angular.IAttributes, ctrls: Array<angular.IController>) => {

            let defaultTimeout = "";

            let ngModelCtrl = ctrls[0];
            let selfCtrl = ctrls[1];
            let qpFormCtrl = ctrls[2];

            selfCtrl.itemName = attributes.name;

            selfCtrl.qpFormCtrl = qpFormCtrl;

            selfCtrl.__modelCtrl = ngModelCtrl;

            // 检测属性名
            if (!attributes.name) {
                throw new Error("");
            }

            // 监听后验证执行完成事件
            eventBus.addEventListener(PostValidationEvent.VALIDATE_COMPLETE, selfCtrl.postValidateComplete, scope)

            let _mv;
            let _vv;

            ngModelCtrl.$asyncValidators.postValidate = function (modelValue, viewValue) {
                // 创建promise
                let deferred = $q.defer();

                selfCtrl.__deferred = deferred;

                _mv = modelValue;
                _vv = viewValue;

                let eventName = PostValidationEvent.POSTVALIDATE;
                // 通过eventbus执行后验证
                eventBus.dispatch(eventName, {
                    modelValue: _mv,
                    viewValue: _vv,
                    itemName: attributes.name
                });

                return deferred.promise;
            }


        }
    }
}

PostValidationDirective.$inject = ["eventBus", "$q"];